import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React from 'react';


import Spinner from '@atlaskit/spinner';
import { ButtonGroup } from '@atlaskit/button';

import { ActionsContainer, Container, Description, Header, Image, SpinnerContainer } from '../styled';

var EmptyState = function (_React$Component) {
  _inherits(EmptyState, _React$Component);

  function EmptyState() {
    _classCallCheck(this, EmptyState);

    return _possibleConstructorReturn(this, (EmptyState.__proto__ || _Object$getPrototypeOf(EmptyState)).apply(this, arguments));
  }

  _createClass(EmptyState, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          header = _props.header,
          description = _props.description,
          size = _props.size,
          imageUrl = _props.imageUrl,
          maxImageWidth = _props.maxImageWidth,
          maxImageHeight = _props.maxImageHeight,
          primaryAction = _props.primaryAction,
          secondaryAction = _props.secondaryAction,
          tertiaryAction = _props.tertiaryAction,
          isLoading = _props.isLoading;


      var actionsContainer = primaryAction || secondaryAction || isLoading ? React.createElement(
        ActionsContainer,
        null,
        React.createElement(
          ButtonGroup,
          null,
          primaryAction,
          secondaryAction
        ),
        React.createElement(
          SpinnerContainer,
          null,
          isLoading && React.createElement(Spinner, null)
        )
      ) : null;

      return React.createElement(
        Container,
        { size: size },
        imageUrl && React.createElement(Image, {
          src: imageUrl,
          maxWidth: maxImageWidth,
          maxHeight: maxImageHeight
        }),
        React.createElement(
          Header,
          null,
          header
        ),
        description && React.createElement(
          Description,
          null,
          description
        ),
        actionsContainer,
        tertiaryAction
      );
    }
  }]);

  return EmptyState;
}(React.Component);

EmptyState.defaultProps = {
  size: 'wide',
  maxImageWidth: 160,
  maxImageHeight: 160
};
export default EmptyState;